import Pending from '@app/store/action/pending';
import Notification from '@app/store/action/notification';
import ActionHelper from '@module/redux-actions';
import API from '@app/api';

export const actions = ActionHelper.types([
  'GET_API_GRANTS',
  'DELETE_API_GRANT_SUCCESS',
]);

export default ActionHelper.generate({
  getApiGrants() {
    const pendingId = 'getApiGrants';

    return async (dispatch) => {
      dispatch(Pending.setPending(pendingId));

      try {
        const response = await API.ApiGrants.getApiGrants();

        dispatch({
          type: actions.GET_API_GRANTS,
          details: response.body || [],
        });
      } catch (error) {
        dispatch(
          Notification.setNotification('error', 'retrieve_device_exception')
        );
      }

      dispatch(Pending.resetPending(pendingId));
    };
  },

  removeApiGrant(apiGrantId) {
    const pendingId = 'removeApiGrant';

    return async (dispatch) => {
      dispatch(Pending.setPending(pendingId));

      try {
        await API.ApiGrants.removeApiGrant(null, {
          pathExtValues: {
            apiGrantId,
          },
        });

        dispatch({
          type: actions.DELETE_API_GRANT_SUCCESS,
          apiGrantId,
        });
      } catch (error) {
        dispatch(
          Notification.setNotification('error', 'remove_device_exception')
        );
      }

      dispatch(Pending.resetPending(pendingId));
    };
  },
});
